import authService from '@/services/authService'

export const authIframe = async (iframeWindow) => {
  const appAuth = {
    access_token: authService.getAccessToken(),
    authorities: authService.getRoles(),
    email: authService.getUserEmail(),
    expires_in: authService.getAccessTokenExpiration() * 1000,
    logged_in: authService.isLoggedIn(),
    refresh_token: authService.getRefreshToken()
  }

  iframeWindow?.postMessage(
    {
      type: 'app_auth',
      app_auth: appAuth
    },
    '*'
  )
}

/**
 * Other systems would receive this value from the API as a `route_version` field. For simplicity, the logic is duplicated here
 *
 * @param {String} baseUrl - https://practitioner.microba.com etc - base URL where report is served.
 * @param {String} versionedReportId - R1xxxx-1, R2xxxx-2, R3xxxxx-1
 * @param {String} productCode - "metaxplore" | "metaxplore-gi" | "metaxplore-gi-plus" | "microbiome-explorer-gi-assessment"
 */
export function getPreviewUrl(baseUrl, versionedReportId, productCode) {
  const prefix = versionedReportId?.substring(0, 2) || ''

  switch (prefix) {
    case 'R3':
      return `${baseUrl}/report/v3/${versionedReportId}`
    case 'R2': {
      if (productCode === 'microbiome-explorer-gi-assessment') {
        return `${baseUrl}/report/v3/${versionedReportId}`
      } else {
        return `${baseUrl}/report/v2/${versionedReportId}`
      }
    }

    // R1 not handled as this is only a podium report url util
  }

  throw new Error(`Unable to determine report url: [resultId: ${versionedReportId}] [productCode: ${productCode}]`)
}

export const CHILD_REPORT_LOADED_MSG = 'child_report_loaded'
export const APP_AUTH_MSG = 'app_auth'
export const RESEND_AUTH_MSG = 'resend_auth'
